import SocketNotificationStatus from 'core/constants/SocketNotificationStatus';

export default function getSocketEventStatus(record) {
  const isFailed = record?.status === SocketNotificationStatus?.failed || false;

  const isLoading = record?.status === SocketNotificationStatus?.inprogress;

  return { isFailed, isLoading };
}
